import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import LoadingFade from "../../LoadingFade";
import {useState, useEffect, useRef, createRef, useCallback } from "react";
import {useNavigate, useParams} from "react-router-dom";
import httpService from "../../../services/httpService";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Card from 'react-bootstrap/Card';
import Heading3 from "../../Heading3";
import SkillButton from "../SkillButton";
import Collapse from "react-bootstrap/Collapse";
import {FaRegTrashAlt, FaBookOpen, FaPlayCircle} from "react-icons/fa";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import {Modal, Spinner} from "react-bootstrap";
import Cropper from 'react-easy-crop';
import eventBus from "../../../services/eventBus";

const newSkillTemplate = {
    "title" : "",
    "description" : ""
};
const StepTitles = ({onStageChange, onClubChange, podcastClub, hasTestingClub}) => {
    const { step, id } = useParams();
    const navigate = useNavigate();
    const [detailsLoading, setDetailsLoading] = useState(false);
    const [pageLoading, setPageLoading] = useState(true);
    const [isWizardCompleted, setIsWizardCompleted] = useState(false);
    const [hasSubscribedListeners, setHasSubscribedListeners] = useState(false);

    const [podcastClubInner, setPodcastClubInner] = useState({
        title: "",
        description: "",
        use_in_processing: 1,
        is_testing: 0,
    });
    const [podcastClubErrors, setPodcastClubErrors] = useState({});
    const [errorMessage, setErrorMessage] = useState('');

    const [openInfo, setOpenInfo] = useState(false);
    const [showVideoModal, setShowVideoModal] = useState(false);

    const nodeRefs = useRef({});

    useEffect(() => {
        // Example: fetching the authenticated user's info
        setDetailsLoading(true);
        if(podcastClub){
            setPodcastClubInner(podcastClub)
        } else {
            loadClub()
        }
        setDetailsLoading(false);
    }, [podcastClub]);

    const loadClub = async() => {
        let endpoint_with_params = "/dash/wizard/get-step/1"+ (id ? "/"+id : "") + (!id && podcastClub ? "/"+podcastClub.guid : '')
        httpService.get(endpoint_with_params)
            .then((res) => {
                if(res.data.podcast_club){
                    onClubChange(res.data.podcast_club)
                    // setPodcastClubInner({...res.data.podcast_club})
                }
                setIsWizardCompleted(res.data.is_wizard_completed)
                setHasSubscribedListeners(res.data.has_subscribed_listeners)
            })
            .catch((err) => {
                setErrorMessage(err.response?.data?.message || "Error loading data");
            }).finally(() => {
            console.log(podcastClubInner)
            setDetailsLoading(false);
            setPageLoading(false)
        });
    }

    const handleSaveClub = async (e) => {
        setDetailsLoading(true)
        try {
            const res = await httpService.put("dash/club/"+podcastClub.guid,podcastClubInner);
            console.log("parsed:", res.data);
            onClubChange(res.data.data)
            setErrorMessage('')
            setPodcastClubErrors({})
            goToNextStep()
        } catch (err) {
            setPodcastClubErrors({...err.response.data.errors})
        } finally {
            setDetailsLoading(false)
            setPageLoading(false)
        }
    };

    const handleCreateClub = async (e) => {
        setDetailsLoading(true)
        try {
            const res = await httpService.post("dash/club",podcastClubInner);
            // console.log("parsed:", res.data);
            onClubChange(res.data.data)
            setErrorMessage('')
            setPodcastClubErrors({})
            goToNextStep(res.data.data.guid)
        } catch (err) {
            console.error('error', err)
            // setPodcastClubErrors({...err.response.data.errors})
        } finally {
            setDetailsLoading(false)
            setPageLoading(false)
        }
    };

    const handleDetailsChange = (e) => {
        console.log(e)
        if(e.target.name === 'use_in_processing' || e.target.name === 'is_testing'){
            setPodcastClubInner({ ...podcastClubInner, [e.target.name]: e.target.checked ? 1 : 0});
        } else {
            setPodcastClubInner({ ...podcastClubInner, [e.target.name]: e.target.value });
        }
    }

    const goToNextStep = (guid = null) => {
        setPageLoading(true)
        onStageChange(2, guid??podcastClub.guid)
    };

    const goToClubDashboard = () => {
        setPageLoading(true)
        navigate(`/podcaster/podcast-club/${podcastClub.guid}`)
    };

    return(
        <LoadingFade loading={pageLoading} stateKey={pageLoading?'loading':'not-loading'}>
            <Row className={'pb-3'}>
                <Col sm={12}>
                    <p>This helps listeners understand what the club is about. You can change this later.</p>
                    <div className="wizard-help wizard-help--prominent">
                        <p className="wizard-help__lead">First time building a club? Start here.</p>
                        <button type="button" className="wizard-help-btn" aria-expanded={openInfo} aria-controls="delete-collapse" onClick={() => setOpenInfo(!openInfo)}>
                            <FaBookOpen aria-hidden="true" /> How to write a strong description
                        </button>
                        <button type="button" className="wizard-help-btn" onClick={() => setShowVideoModal(true)}>
                            <FaPlayCircle aria-hidden="true" /> Watch a 1-minute walkthrough
                        </button>
                    </div>
                </Col>
                <Col sm={12}>
                    <Collapse in={openInfo}>
                        <div id="delete-collapse" className="w-100 m-0 p-0">
                            <h3>How to write a strong Podcast Club description</h3>
                            <p>
                                The best descriptions make it clear why the club exists and what listeners will get from it.
                            </p>
                            <h4>A simple way to structure it:</h4>
                            <ul>
                                <li>The problem your listeners are facing</li>
                                <li>Why it matters or keeps showing up</li>
                                <li>How this club helps using your existing episodes</li>
                                <li>What changes for listeners by the end</li>
                            </ul>
                            <h4>Example:</h4>
                            <p>
                                Many leaders understand the theory, but struggle to apply it day to day. This Podcast Club helps you turn leadership ideas into weekly practices, using selected episodes as prompts. By the end, you’ll have tried, reflected on, and adapted ideas you can actually use at work.
                            </p>
                            <p>
                                Don’t overthink this. Clear and specific beats clever every time.
                            </p>
                        </div>
                    </Collapse>
                </Col>
                <Col sm={12}>
                  <div className="wizard-box">
                    <Form.Group className="mb-3" controlId="podacstClubDetails">
                            <Form.Label>Podcast Club Title <span className="text-muted fw-normal">— This becomes the name listeners see on the club, so write it as the thing they'd tell a colleague, not a working title.</span></Form.Label>
                            <Form.Control
                                name={'title'}
                                value={podcastClubInner.title}
                                type="text"
                                placeholder="Example: Building Better Product Teams"
                                onChange={handleDetailsChange}
                                isInvalid={podcastClubErrors.hasOwnProperty('title')}
                                disabled={detailsLoading}
                                className={"mb-2"}
                            />
                            <Form.Control.Feedback type="invalid">
                                {podcastClubErrors?.title ?? ""}
                            </Form.Control.Feedback>
                        </Form.Group>
                    <Form.Group className="" controlId="description">
                            <Form.Label>Podcast Club Description <span className="text-muted fw-normal">— Listeners read this before they join, and Podsy reads it later to find the moments in your episodes worth talking about. The clearer you are about who it's for, the sharper those insights will be.</span></Form.Label>
                            <Form.Control
                                value={podcastClubInner.description}
                                name={'description'}
                                as="textarea"
                                rows={5}
                                type="text"
                                placeholder="A short explanation of what listeners will work on as they follow the episodes."
                                onChange={handleDetailsChange}
                                isInvalid={podcastClubErrors.hasOwnProperty('description')}
                                disabled={detailsLoading}
                                className={"mb-2"}
                            />
                            <Form.Control.Feedback type="invalid">
                                {podcastClubErrors?.description ?? ""}
                            </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                </Col>

                {/*<Col sm={6}>*/}
                {/*    <Form.Label>Should Title, Description be used in insights / key takeaways extraction</Form.Label>*/}
                {/*    <Form.Check*/}
                {/*        type="switch"*/}
                {/*        onChange={handleDetailsChange}*/}
                {/*        name={'use_in_processing'}*/}
                {/*        id="custom-switch"*/}
                {/*        checked={!!podcastClubInner.use_in_processing}*/}
                {/*        label="Check this switch"*/}
                {/*    />*/}
                {/*</Col>*/}
                {/*<Col sm={12}>*/}
                {/*    <Form.Label>Is it testing Podcast Club?</Form.Label>*/}
                {/*    <Form.Check*/}
                {/*        type="switch"*/}
                {/*        onChange={handleDetailsChange}*/}
                {/*        name={'is_testing'}*/}
                {/*        id="custom-switch2"*/}
                {/*        checked={!!podcastClubInner.is_testing}*/}
                {/*        label="Check this switch if you want this Podcast CLub to be used for testing purposes only."*/}
                {/*    />*/}
                {/*</Col>*/}
                <Col sm={12} className={'mt-3'}>
                    <Row>
                        <Col sm={2}>
                            <Form.Label>{hasTestingClub ? 'Go to dashboard' : 'Go back to guides'}</Form.Label>
                            <Button
                                variant={'light'}
                                className={'w-100'}
                                onClick={() => hasTestingClub ? navigate('/podcaster-dashboard') : onStageChange('start', podcastClub?.guid)}>
                                {hasTestingClub ? 'Go to dashboard' : 'Guides'}
                            </Button>
                        </Col>
                        <Col sm={4}>
                            {isWizardCompleted ? (
                                <Button
                                    disabled={!(podcastClub?.title && podcastClub?.description)}
                                    variant={'primary'}
                                    className={'w-100'}
                                    onClick={goToClubDashboard}>
                                    Go to club dashboard
                                </Button>
                            ):''}
                        </Col>
                        {/*<Col sm={6}>*/}
                        {/*    <Button*/}
                        {/*        disabled={!(podcastClub?.title && podcastClub?.description)}*/}
                        {/*        variant={isWizardCompleted ? 'light' : 'primary'}*/}
                        {/*        className={'w-100'}*/}
                        {/*        onClick={goToNextStep}>*/}
                        {/*        Add Images*/}
                        {/*    </Button>*/}
                        {/*</Col>*/}
                        {podcastClub?.guid ?
                            <Col sm={6}>
                                <Form.Label>Continue to choose episodes next</Form.Label>
                                <Button disabled={detailsLoading} id={"button-on-the-bottom"} className={"d-block w-100"} variant="primary" onClick={handleSaveClub}>
                                    Save and Continue
                                </Button>
                            </Col>
                            :
                            <Col sm={6}>
                                <Form.Label>Continue to choose episodes next</Form.Label>
                                <Button disabled={detailsLoading} id={"button-on-the-bottom"} className={"d-block w-100"} variant="primary" onClick={handleCreateClub}>
                                    Save and Continue
                                </Button>
                            </Col>
                        }
                    </Row>
                </Col>
            </Row>

            <Modal show={showVideoModal} onHide={() => setShowVideoModal(false)} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>How to write a strong description</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{position: 'relative', paddingBottom: '56.25%', height: 0}}>
                        <iframe
                            src="https://www.loom.com/embed/af21aee8fcee4b1a9a4c7c83071081b9"
                            frameBorder="0"
                            webkitallowfullscreen="true"
                            mozallowfullscreen="true"
                            allowFullScreen
                            style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%'}}
                        />
                    </div>
                </Modal.Body>
            </Modal>
        </LoadingFade>
    )
}

export default StepTitles;